import { Pill } from '@loomhq/lens';
import React from 'react';

import TagLink from '../tag-link';

import {
  AddSuggestedFollow,
  RemoveSuggestedFollow,
} from 'components/layout/navigation/suggested-follows/ToggleSuggestedFollow';

import styles from './styles.module.less';

export default function TagPills({
  tags,
  backgroundColor = 'var(--tagBackground)',
  onAddTag = undefined,
  onRemoveTag = undefined,
}) {
  return (
    <div className={`${styles.tagWrapper} my:small`}>
      {tags?.map(tag => (
        <Pill
          key={tag}
          className={`${
            onAddTag ? styles.pillViewerWithIcons : styles.pillViewer
          } m:xsmall`}
          backgroundColor={backgroundColor}
          icon={
            <>
              {onAddTag && <AddSuggestedFollow onClick={() => onAddTag(tag)} />}
              {onRemoveTag && (
                <RemoveSuggestedFollow onClick={() => onRemoveTag(tag)} />
              )}
            </>
          }
          iconPosition="right"
        >
          <TagLink tag={tag} />
        </Pill>
      ))}
    </div>
  );
}
